import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/base/base.service';
import { Constants } from '../../../app.constants';
import { DistributionChannel } from './distribution-channels.models';
import { RequestService, HttpRequestType } from 'src/app/core/request.service';
import { AlertService } from 'src/app/core/alert.service';

@Injectable({
  providedIn: 'root'
})
export class DistributionChannelsService extends BaseService {

  constructor(protected requestService: RequestService, private alertService: AlertService) {
    super(requestService);
  }
  
  public changeStatus(id: string, activate: boolean, onSuccess: Function, onFail: Function = null) {
    this.requestService.createRequest(HttpRequestType.Patch, `${Constants.contextPath}/distribution-channels/${id}/${activate ? 'activate' : 'deactivate'}`, null, null, (response: DistributionChannel) => {
      onSuccess(response);
    }, (error) => {
      if(onFail != null)
        onFail(error);
      else
        this.alertService.error(error, true);
    });
  }
}
